// Types mirror app/schemas/engagement.py::EngagementResponse.

export type EngagementStatus =
  | "draft"
  | "active"
  | "scanning"
  | "review"
  | "retesting"
  | "completed"
  | "archived";

export interface Engagement {
  id: string;
  display_number: number;
  name: string;
  description: string | null;
  client_name: string | null;
  pentest_type: string;
  status: EngagementStatus | string;
  scope_description: string | null;
  deep_validation_authorized: boolean;
  created_at: string;
  updated_at: string;
  started_at: string | null;
  completed_at: string | null;
  // ISO timestamp set when the user used their one-shot domain change.
  // NULL means the change is still available.
  domain_changed_at: string | null;
}

// Shared status-pill color map. Used by Engagements list, Dashboard
// recent-engagements widget, and anywhere else we render a status.
export const STATUS_BADGE_COLORS: Record<
  string,
  { color: string; bg: string }
> = {
  draft: { color: "rgb(var(--color-muted))", bg: "rgb(var(--color-bg3))" },
  active: { color: "rgb(var(--color-muted))", bg: "rgb(var(--color-bg3))" },
  scanning: { color: "rgb(var(--color-accent))", bg: "rgb(var(--color-accent-bg))" },
  review: { color: "rgb(var(--color-warning))", bg: "rgb(var(--color-warning-bg))" },
  retesting: { color: "rgb(var(--color-brand))", bg: "rgb(var(--color-brand-bg))" },
  completed: { color: "rgb(var(--color-success))", bg: "rgb(var(--color-success-bg))" },
  archived: { color: "rgb(var(--color-dim))", bg: "rgb(var(--color-bg2))" },
};

export function getStatusBadgeColors(status: string) {
  return STATUS_BADGE_COLORS[status] ?? STATUS_BADGE_COLORS.draft;
}
